<div class="list-page" style="max-width: 1200px">
  <form novalidate class="ylaosan-kontrollit">
    <div class="lisaa-nappula-container">
      <button mat-button (click)="lisaa()" type="button" class="primarybutton mat-elevation-z4">
        <mat-icon>add</mat-icon>
        {{ 'maksut.toimittajat.lisaa' | translate | async }}
      </button>
    </div>

    <div class="hakukontrollit">
      <mat-form-field>
        <mat-icon matPrefix class="listaus-haku-ikoni">search</mat-icon>
        <mat-label>{{ 'maksut.toimittajat.etsi' | translate | async }}</mat-label>
        <input type="text" [formField]="lomake.nimi" matInput />
      </mat-form-field>

      <mat-form-field style="width: 150px; margin-left: 100px; margin-right: 25px">
        <mat-label>{{ 'maksut.toimittajat.alkaen' | translate | async }}</mat-label>
        <input matInput [matDatepicker]="dp1" [formField]="lomake.start" />
        <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
        <mat-datepicker #dp1></mat-datepicker>
      </mat-form-field>
      <mat-form-field style="width: 150px">
        <mat-label>{{ 'maksut.toimittajat.loppuen' | translate | async }}</mat-label>
        <input matInput [matDatepicker]="dp2" [formField]="lomake.end" />
        <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
        <mat-datepicker #dp2></mat-datepicker>
      </mat-form-field>
    </div>
  </form>

  <div style="position: relative">
    <mat-table matSort [dataSource]="naytettavatObservable | async" [matSortDisableClear]="true" style="min-height: 94px">
      <ng-container matColumnDef="numero">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="150px"> {{ 'maksut.toimittajat.numero' | translate | async }} </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="150px"> {{ row.numero }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nimi">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'maksut.toimittajat.nimi' | translate | async }} </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.nimi }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="yhteensa">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="200px"> {{ 'maksut.toimittajat.yhteensa' | translate | async }} </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="200px"> {{ row.yhteensa | lmoney | async }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="maksamatta">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="200px"> {{ 'maksut.toimittajat.maksamatta' | translate | async }} </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="200px"> {{ row.maksamatta | lmoney | async }} </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="propertiesToDisplay"></mat-header-row>
      <mat-row (click)="muokkaa(row)" *matRowDef="let row; columns: propertiesToDisplay"></mat-row>
    </mat-table>
    @if (naytaEiYhtaanObservable | async) {
      <div class="table-ladataan" style="position: absolute; top: 0px; width: 100%; height: 100%; display: flex; justify-items: center; align-items: center">
        <div style="width: 100%; padding-top: 40px; text-align: center">
          {{ 'maksut.toimittajat.hakuehdoilla-ei-yhtaan-tulosta' | translate | async }}
        </div>
      </div>
    }
    <div lemon-loading [show]="lataaObservable | async"></div>
  </div>

  <mat-paginator #paginator [length]="dataSource?.rivienMaaraObservable | async" [pageSize]="dataSource?.getPage().pageSize" [pageIndex]="dataSource?.getPage().pageIndex" [pageSizeOptions]="[20, 50, 200]"> </mat-paginator>
</div>
